import * as LucideIcons from "lucide-react";

/**
 * Builds URL to retrieve/create tasks for a specific object
 * Follows convention: /crm/{objectType}/{objectId}/tasks/
 */
export function getTasksEndpointForObject(objectType: string, objectId: number): string {
    return `/crm/${objectType}/${objectId}/tasks/`;
}

/**
 * Retourne l'object_id à partir de l'URL (ex: /opportunities/123/ => 123)
 */
export function getObjectIdForPath(url: string): number | null {
    // Cherche le premier nombre après un slash (ex: /foo/123/ ou /bar/456)
    const match = url.match(/\/(\d+)(?:[/?#]|$)/);
    if (match && match[1]) {
        return parseInt(match[1], 10);
    }
    return null;
}

/**
 * Récupère les métadonnées d'un objet (icône, couleur) depuis le localStorage
 * en utilisant soit l'URL, soit le type d'objet directement
 */
export function getObjectMetadata(urlOrObjectType: string): {
    icon: any;
    color: string;
    modelName?: string;
    contentTypeId?: number;
} {
    // Essayer de trouver les métadonnées correspondantes
    for (const key in localStorage) {
        if (key.startsWith("options-metadata:")) {
            const cached = localStorage.getItem(key);
            if (cached) {
                try {
                    const { data } = JSON.parse(cached);

                    // Matcher par object_url si c'est une URL complète
                    const matchByUrl = data?.object_url && data.object_url === `/${urlOrObjectType}`;

                    // Matcher par object_type si c'est un type d'objet
                    const matchByObjectType = data?.object_type && data.object_type === urlOrObjectType;

                    // Matcher par model name si c'est un type d'objet
                    const modelName = data?.model_metadata?.model_name || data?.model_name;
                    const matchByModelName = modelName && modelName.toLowerCase() === urlOrObjectType.toLowerCase();

                    if (matchByUrl || matchByObjectType || matchByModelName) {
                        const iconName = data?.model_metadata?.icon || "Star";
                        const color = data?.model_metadata?.color || "#888";
                        const contentTypeId = data.reference_type || data.content_type_id || data?.meta?.content_type_id;

                        const iconRaw = LucideIcons[iconName as keyof typeof LucideIcons];
                        const icon = iconRaw && (iconRaw as any).$$typeof ? iconRaw : LucideIcons.Star;

                        return {
                            icon,
                            color,
                            modelName: modelName || undefined,
                            contentTypeId: contentTypeId || undefined
                        };
                    }
                } catch {
                    continue;
                }
            }
        }
    }

    // Fallback par défaut
    return { icon: LucideIcons.File, color: "#888" };
}

/**
 * Retourne le reference_type (content_type_id) à partir de l'URL courante en utilisant le cache metadata (object_url)
 */
export function getReferenceTypeForPath(url: string): number | null {
    // Parcourt toutes les clés de cache metadata
    for (const key in localStorage) {
        if (key.startsWith("options-metadata:")) {
            const cached = localStorage.getItem(key);
            if (cached) {
                try {
                    const { data } = JSON.parse(cached);

                    // object_url doit matcher le début du path courant
                    if (data?.object_url && url.startsWith(`/${data.object_url}`)) {
                        return data.reference_type || data.content_type_id || data?.meta?.content_type_id || null;
                    }
                } catch {
                    continue;
                }
            }
        }
    }
    return null;
}
